export default __webpack_public_path__ + "static/media/nigeria2.1c6aea5a.jpg";